"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineBarChartTooltip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var isNil_1 = tslib_1.__importDefault(require("lodash/fp/isNil"));
var Components_1 = require("../../../Components");
var chartUtils_1 = require("../../chartUtils");
var ChartTooltipUtils_1 = require("../ChartTooltipUtils");
var ChartTooltipStyles_1 = require("../ChartTooltipStyles");
exports.LineBarChartTooltip = function (_a) {
    var data = _a.data, colorScale = _a.colorScale, _b = _a.dataLabel, dataLabel = _b === void 0 ? { line: '', bar: '' } : _b;
    var filteredData = data.filter(function (d) { return !(!d.lineValue && !d.barValue); });
    return (react_1.default.createElement(react_1.default.Fragment, null, data.length > 0 && (react_1.default.createElement(ChartTooltipStyles_1.StyledContent, null,
        react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, null,
            react_1.default.createElement(HeaderRow, null,
                react_1.default.createElement(HeaderLabel, null, dataLabel.line),
                react_1.default.createElement(HeaderLabel, null, dataLabel.bar))),
        filteredData.map(function (d) {
            var _a, _b, _c, _d;
            return (react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, { key: d.ID },
                react_1.default.createElement(Components_1.Icon, { name: d.icon, style: { color: colorScale(d), fontSize: '1.6rem' } }),
                react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemLabel, null, d.label),
                react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemValue, { style: {
                        color: ((_a = d === null || d === void 0 ? void 0 : d.lineValue) === null || _a === void 0 ? void 0 : _a.y) < 0 ? ChartTooltipUtils_1.NEGATIVE_COLOR : ChartTooltipUtils_1.POSITIVE_COLOR,
                    } }, !isNil_1.default((_b = d === null || d === void 0 ? void 0 : d.lineValue) === null || _b === void 0 ? void 0 : _b.y)
                    ? chartUtils_1.formatLinearNumbers(d.lineValue.y)
                    : ''),
                react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemValue, { style: {
                        color: ((_c = d === null || d === void 0 ? void 0 : d.barValue) === null || _c === void 0 ? void 0 : _c.y) < 0 ? ChartTooltipUtils_1.NEGATIVE_COLOR : ChartTooltipUtils_1.POSITIVE_COLOR,
                    } }, !isNil_1.default((_d = d === null || d === void 0 ? void 0 : d.barValue) === null || _d === void 0 ? void 0 : _d.y)
                    ? chartUtils_1.formatLinearNumbers(d.barValue.y)
                    : '')));
        })))));
};
exports.LineBarChartTooltip.displayName = 'FOS__LineBarChartTooltip';
var HeaderRow = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-left: 17rem;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-left: 17rem;\n"])));
var HeaderLabel = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  width: 7.6rem;\n  text-align: right;\n"], ["\n  font-family: ", ";\n  width: 7.6rem;\n  text-align: right;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
});
var templateObject_1, templateObject_2;
